import { useTranslation } from 'react-i18next';

import { Action, Icon } from '@soluto-private/mx-asurion-ui-react';

import { useAnalytics } from '@service-initiation/shared-data-access-analytics';
import { TranslationEntries } from '@service-initiation/tech-care-data-access-i18n';
import { getGoogleMapUrl } from '@service-initiation/tech-care-utils-helpers';

export interface GetDirectionsProps {
  address: string | undefined;
  variant?: 'button' | 'link';
}

const TEXT = TranslationEntries.Repairs.Confirmation;

export const GetDirections = ({ address, variant }: GetDirectionsProps) => {
  const url = getGoogleMapUrl(address);
  const { t } = useTranslation();
  const { dispatchClickEvent } = useAnalytics();

  const handleClick = () => {
    dispatchClickEvent('GetDirections', { address });
    window.open(url);
  };

  return variant === 'link' ? (
    <Action
      color="secondary"
      data-testid="GetDirections"
      onClick={handleClick}
      target="_blank"
      variant="flat"
    >
      {t(TEXT.GetDirections)}
    </Action>
  ) : (
    <Action
      color="primary"
      data-testid="GetDirections"
      onClick={handleClick}
      size="md"
      variant="outline"
    >
      <Icon src="location-map" />
      {t(TEXT.GetDirections)}
    </Action>
  );
};
